<template>
  <div class="tw-w-full tw-text-white" :class="headerNav">
    <nav
      class="tw-mx-auto tw-flex tw-w-3/4 tw-items-center tw-justify-between tw-gap-4 tw-pb-4 tw-pt-3"
    >
      <div class="tw-flex tw-w-full tw-items-center tw-justify-center tw-gap-4 lg:tw-justify-start">
        <NuxtLink
          :to="'/'"
          @click="$analytics.trackElementClicked({ text: 'Logo', elementType: 'navigation' })"
        >
          <CaseWiseHeaderLogo v-if="cobrandedExperience" />
          <WhiteCaseWiseLogo v-else />
        </NuxtLink>
        <div v-if="cobrandedExperience" class="tw-hidden sm:tw-block">
          <TorticityLogo />
        </div>
      </div>
      <div class="tw-hidden tw-items-center tw-gap-6 tw-whitespace-nowrap tw-text-sm lg:tw-flex">
        <NuxtLink
          to="/"
          class="tw-rounded-lg tw-bg-opacity-80 tw-p-2 hover:tw-bg-white hover:tw-bg-opacity-25 hover:tw-text-white"
          :active-class="activeNavItem"
          @click="handleNavClick('Home')"
        >
          Home
        </NuxtLink>
        <NuxtLink
          to="/files"
          class="tw-rounded-lg tw-bg-opacity-80 tw-p-2 hover:tw-bg-white hover:tw-bg-opacity-25 hover:tw-text-white"
          :active-class="activeNavItem"
          @click="handleNavClick('My files')"
        >
          My files
        </NuxtLink>
        <NuxtLink
          to="/help"
          class="tw-rounded-lg tw-bg-opacity-80 tw-p-2 hover:tw-bg-white hover:tw-bg-opacity-25 hover:tw-text-white"
          :active-class="activeNavItem"
          @click="handleNavClick('Contact us')"
        >
          Contact us
        </NuxtLink>
        <button
          v-if="$flagsmith.hasFeature('casewise_support_request')"
          type="button"
          class="tw-rounded-lg tw-bg-opacity-80 tw-p-2 hover:tw-bg-white hover:tw-bg-opacity-25 hover:tw-text-white"
          @click="handleReportIssueClick"
        >
          Report issue
        </button>
      </div>
      <UserAvatar
        class="tw-rounded-lg tw-p-2"
        :class="
          isActive
            ? activeNavItem
            : 'hover:tw-cursor-pointer hover:tw-bg-white hover:tw-bg-opacity-25 hover:tw-text-white'
        "
      />
    </nav>
  </div>
</template>

<script setup lang="ts">
import CaseWiseHeaderLogo from '~/assets/icons/CaseWiseHeaderLogo.svg'
import WhiteCaseWiseLogo from '~/assets/icons/WhiteCaseWiseLogo.svg'
import TorticityLogo from '~/assets/icons/WhitePoweredByTorticity.svg'

const branding = useBrand()
const cobrandedExperience = computed(() => branding.value.brandingExperience === 'cobrand')

const { getThemeTokenString } = useTheme()
const activeNavItem = getThemeTokenString('header-active-item')
const headerNav = getThemeTokenString('header-nav')

const { isDropdownOpen, closeDropdown } = useProfileDropdown()

const isActive = computed(() => isDropdownOpen.value)

const { $analytics } = useNuxtApp()
const handleNavClick = (label: string) => {
  $analytics.trackElementClicked({ text: label, elementType: 'navigation' })
  closeDropdown()
}

const { open: openReportIssue } = useReportIssueDrawer()

const handleReportIssueClick = () => {
  $analytics.trackElementClicked({ text: 'report issue', elementType: 'navigation' })
  closeDropdown()
  openReportIssue()
}
</script>
